function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 14.6C11.6451 14.6 14.6 11.6451 14.6 8C14.6 4.35492 11.6451 1.4 8 1.4C4.35492 1.4 1.4 4.35492 1.4 8C1.4 11.6451 4.35492 14.6 8 14.6ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#172342"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.2648 4.26382C4.61682 3.9118 5.18756 3.9118 5.53958 4.26382L8.00078 6.72502L10.462 4.26382C10.814 3.9118 11.3847 3.9118 11.7368 4.26382C12.0888 4.61584 12.0888 5.18658 11.7368 5.53861L9.27557 7.99981L11.7368 10.461C12.0888 10.813 12.0888 11.3838 11.7368 11.7358C11.3847 12.0878 10.814 12.0878 10.462 11.7358L8.00078 9.27459L5.53958 11.7358C5.18756 12.0878 4.61682 12.0878 4.2648 11.7358C3.91278 11.3838 3.91278 10.813 4.2648 10.461L6.726 7.99981L4.2648 5.53861C3.91278 5.18658 3.91278 4.61584 4.2648 4.26382Z",
  fill: "#172342"
});

function SvgDeleteCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircleIcon);
export default __webpack_public_path__ + "static/media/DeleteCircleIcon.045b65a4.svg";
export { ForwardRef as ReactComponent };